import React from "react";
import { FaEdit } from "react-icons/fa";
import "./ReadOnlyField.scss";

interface ReadOnlyFieldProps {
  label: string;
  value: string | React.ReactNode;
  onEditClick?: () => void;
}

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
  label,
  value,
  onEditClick,
}) => {
  return (
    <div className="read-only-field">
      <div className="label">
        <span className="label-text">{label}</span>
        {!!onEditClick && (
          <span className="edit-link" onClick={onEditClick}>
            <FaEdit size={16} />
          </span>
        )}
      </div>
      <div className="value-wrapper">{value}</div>
    </div>
  );
};

export default ReadOnlyField;
